import { createAuthClient } from 'better-auth/react'
import { adminClient, organizationClient } from 'better-auth/client/plugins'

const baseURL =
  import.meta.env.VITE_API_URL || 'https://admin-api.stgeorgeenglish.com'

export const authClient = createAuthClient({
  baseURL,
  plugins: [organizationClient(), adminClient()],
})

export const {
  signIn,
  signUp,
  signOut,
  useSession,
  updateUser,
  changePassword,
  requestPasswordReset,
  resetPassword,
} = authClient
